import React from 'react';
import classNameBind from 'classnames/bind';
import { useTranslation } from '../Translator';
import Icon from '../Icon';
import Link from '../Link';
import styles from './HelpLink.module.css';

const bindClasses = classNameBind.bind(styles);

const HelpLink = ({
  children,
  href = null,
  onClick = null,
  target = '_blank',
  dataId = 'HelpLink',
}) => {
  const { t } = useTranslation('components');

  return (
    <div
      className={bindClasses('wrapper')}
      data-ppuc-id={dataId}
    >
      <Icon
        name="info-circle"
        color="blue"
      />
      <div
        className={bindClasses('label')}
        data-ppuc-id={`${dataId}.label`}
      >
        {`${t('helpLinkReadMore')}: `}
      </div>
      <Link
        href={href}
        onClick={onClick !== null ? () => { onClick(); } : null}
        target={target}
        size="small"
        dataId={`${dataId}.link`}
      >
        {children}
      </Link>
    </div>
  );
};

export { HelpLink };
